import { createPortal } from 'react-dom';
import { useToastStore } from '../hooks/use-toast';
import { ToastItem } from './toast';

/**
 * Mount <Toaster /> once at the app root (inside the root layout component).
 * It renders toasts in a fixed overlay via a React portal so z-index stacking
 * is always correct regardless of where in the component tree it lives.
 */
export function Toaster() {
  const { toasts, dismiss } = useToastStore();

  if (typeof document === 'undefined' || !toasts.length) return null;

  return createPortal(
    <div
      aria-label="Notifications"
      className="fixed bottom-4 right-4 z-[200] flex flex-col-reverse gap-2 w-full max-w-[380px] pointer-events-none sm:bottom-6 sm:right-6"
    >
      {toasts.map((item) => (
        <div key={item.id} className="pointer-events-auto">
          <ToastItem item={item} onDismiss={dismiss} />
        </div>
      ))}
    </div>,
    document.body,
  );
}
